// Lightweight offline cache for raw Bible passage text (item 6).
// Only the passage verses are cached so a previously viewed passage stays
// readable without a connection. Companion, Strong's, and search still need the network.
const KEY = "openword_passages";

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function keyFor(reference, translation) {
  return `${(reference || "").trim().toLowerCase()}|${translation || ""}`;
}

export function savePassage(reference, translation, data) {
  if (!reference || !data || !(data.verses || []).length) return;
  const all = readAll();
  all[keyFor(reference, translation)] = {
    reference: data.reference || reference,
    translation: data.translation || translation,
    translation_name: data.translation_name || "",
    copyright: data.copyright || "",
    verses: data.verses,
    ok: true,
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {}
}

export function getPassage(reference, translation) {
  return readAll()[keyFor(reference, translation)] || null;
}
